module.exports = __webpack_public_path__ + "img/heidi-strauss.1cda4c79.jpg";